// ============================================================
// api/adminPlatform.js
// Platform-management endpoints (EventTypes / TrainingTypes /
// NotificationTypes / AuditTemplates) for the Phase 2 Admin UI.
// ============================================================

import { apiGet, apiPost, apiPatch, apiPut } from './client';

// ── Event Types ──────────────────────────────────────────────
export const listPlatformEventTypes        = ()                  => apiGet('/mgmt/admin/platform/event-types');
export const createPlatformEventType       = (body)              => apiPost('/mgmt/admin/platform/event-types', body);
export const patchPlatformEventType        = (eventTypeId, body) => apiPatch(`/mgmt/admin/platform/event-types/${encodeURIComponent(eventTypeId)}`, body);

// ── Training Types ───────────────────────────────────────────
export const listPlatformTrainingTypes     = ()                     => apiGet('/mgmt/admin/platform/training-types');
export const createPlatformTrainingType    = (body)                 => apiPost('/mgmt/admin/platform/training-types', body);
export const patchPlatformTrainingType     = (trainingTypeId, body) => apiPatch(`/mgmt/admin/platform/training-types/${encodeURIComponent(trainingTypeId)}`, body);

// ── Notification Types ───────────────────────────────────────
export const listPlatformNotificationTypes = ()                         => apiGet('/mgmt/admin/platform/notification-types');
export const patchPlatformNotificationType = (notificationTypeId, body) => apiPatch(`/mgmt/admin/platform/notification-types/${encodeURIComponent(notificationTypeId)}`, body);

// ── Operator Notifications (Slice D 2026-07-11) ──────────────
// Per-type on/off + channel override for the internal A2Z IT
// operator alerts (PlatformOperatorNotifications).
export const listOperatorNotifications = ()              => apiGet('/mgmt/admin/platform/operator-notifications');
export const patchOperatorNotification = (typeKey, body) => apiPatch(`/mgmt/admin/platform/operator-notifications/${encodeURIComponent(typeKey)}`, body);

// ── Service Notifications (2026-08-14 broadcast) ─────────────
// The A2Z IT bell-only broadcast to managers + admins (maintenance,
// outages, releases). send with { dryRun: true } returns the
// byte-identical preview + recipient count with zero writes.
export const listServiceNotificationTemplates = ()     => apiGet('/mgmt/admin/platform/service-notifications/templates');
export const sendServiceNotification          = (body) => apiPost('/mgmt/admin/platform/service-notifications/send', body);
export const listServiceNotificationHistory   = ()     => apiGet('/mgmt/admin/platform/service-notifications/history');

// ── Audit Templates ──────────────────────────────────────────
export const listPlatformAuditTemplates    = ()                  => apiGet('/mgmt/admin/platform/audit-templates');
export const getPlatformAuditTemplate      = (templateId)        => apiGet(`/mgmt/admin/platform/audit-templates/${encodeURIComponent(templateId)}`);
export const createPlatformAuditTemplate   = (body)              => apiPost('/mgmt/admin/platform/audit-templates', body);
export const patchPlatformAuditTemplate    = (templateId, body)  => apiPatch(`/mgmt/admin/platform/audit-templates/${encodeURIComponent(templateId)}`, body);

// ── Audit Template builder (versions / structure / publish) ──
// versions: clones the given template into a new inactive draft and
// returns { auditTemplateId (the NEW draft id), version, ... }.
// structure: replaces the whole section/question tree of a draft
// (409 template_in_use once any audit instance references it).
// publish: activates a draft, retiring the previously active version
// and repointing audit schedules.
export const createPlatformAuditTemplateVersion = (templateId)           => apiPost(`/mgmt/admin/platform/audit-templates/${encodeURIComponent(templateId)}/versions`);
export const putPlatformAuditTemplateStructure  = (templateId, sections) => apiPut(`/mgmt/admin/platform/audit-templates/${encodeURIComponent(templateId)}/structure`, { sections });
export const publishPlatformAuditTemplate       = (templateId)           => apiPost(`/mgmt/admin/platform/audit-templates/${encodeURIComponent(templateId)}/publish`);

// ── Quality Statements ───────────────────────────────────────
// The 34 CQC Quality Statements ({ items, total }); read-only
// catalogue consumed by the audit template builder's QS mapping
// picker.
export const getPlatformQualityStatements  = () => apiGet('/mgmt/admin/platform/quality-statements');
